/** 家屋の色分け　*/
export const buildingColor = {
  JUDGED_RANK_A: 'green',
  JUDGED_RANK_B: 'yellow',
  JUDGED_RANK_C: 'red',
  SELECTED: 'green',
  EDIT: 'blue',
  SELECTABLE: 'gray'
} as const
